import { useRef } from 'react';
import { Plus } from '@phosphor-icons/react';
import { FAQ_ITEMS } from './landingContent';
import { LANDING_EVENTS, trackLandingEvent } from './landingAnalytics';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

/**
 * Native <details> accordion so answers are always present in the HTML.
 * Only one item stays open at a time.
 */
function LandingFaq() {
  const listRef = useRef(null);
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  const handleToggle = (event, id) => {
    const details = event.currentTarget;
    if (!details.open) return;
    trackLandingEvent(LANDING_EVENTS.faqOpened, { question_id: id });
    const list = listRef.current;
    if (!list) return;
    list.querySelectorAll('details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  };

  return (
    <section className="lp-section lp-faq" aria-labelledby="lp-faq-heading">
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <h2 id="lp-faq-heading" className="lp-heading lp-faq__heading">
            Frequently asked questions
          </h2>
          <div className="lp-faq__list" ref={listRef}>
            {FAQ_ITEMS.map((item) => (
              <details
                className="lp-faq__item"
                key={item.id}
                onToggle={(event) => handleToggle(event, item.id)}
              >
                <summary className="lp-faq__summary">
                  <span>{item.question}</span>
                  <Plus size={16} weight="bold" aria-hidden="true" className="lp-faq__icon" />
                </summary>
                <div className="lp-faq__answer">
                  <p>{item.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingFaq;
